import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";

import { MenuItem } from "../../menu-item";

import "./top-bar.m.css";

export const TopNav = () => {
  const menu = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "headerMenu"], []));

  return menu.map((item) => (
    <li key={item.title} styleName="menu-wrapper">
      <MenuItem item={item} menuStyle="menu-link" />
    </li>
  ));
};
